import React, { useCallback } from 'react'

import { Icon, palette } from '@centivo/react-components'

import { useHistory } from 'react-router-dom'
import { formatNameWithTitle } from 'src/context/results/helpers'
import { IPractitioner } from 'src/shared/types'
import { useSliceTemplate } from 'src/context/global'
import { generatePractitionerDetailsKey } from 'src/refactor/hooks/use-practitioner-details/usePractitionerDetails'
import { ProviderCardPractitionerItem } from './ProviderResultListItemPractitionerItem.styled'

export const ProviderResultListItemPractitionerItem: React.FC<
  IPractitioner
> = ({
  taxonomyDisplay,
  primarySpecialty,
  firstName,
  lastName,
  title,
  lat,
  long,
  practiceName,
  npi,
  network,
  state,
  city,
  zipCode,
  address1,
  address2,
  distance = 20,
  virtualOption,
}) => {
  const history = useHistory()

  const goToDetails = useCallback(() => {
    const queryString = new URLSearchParams({
      ...generatePractitionerDetailsKey({
        npi,
        latitude: lat.toString(),
        longitude: long.toString(),
        network,
        state,
        city,
        zipCode,
        address1,
        address2: address2 ?? '',
        practiceName,
      }),
      providerDistance: distance.toString(),
    }).toString()
    history.push(`/doctorDetails?${queryString}`)
  }, [history, lat, long, network, npi, practiceName, distance])

  const hasVirtualCare = (virtualOption || 'n').toLowerCase().trim() !== 'n'
  const isSliceTemplate = useSliceTemplate()

  return (
    <ProviderCardPractitionerItem
      onClick={goToDetails}
      aria-label={`Tap to see more details about ${formatNameWithTitle(
        firstName,
        lastName,
        title
      )}, ${taxonomyDisplay}`}
    >
      <article>
        <h3>
          {formatNameWithTitle(firstName, lastName, title)}
          {hasVirtualCare && (
            <Icon
              icon={isSliceTemplate ? 'slice-video' : 'video'}
              color={palette.brand.brown}
              size={isSliceTemplate ? '1.5rem' : '1rem'}
              aria-hidden
            />
          )}
        </h3>
        <span>{taxonomyDisplay}</span>
        {!isSliceTemplate && (
          <Icon
            icon="chevron-right"
            color="#44190a"
            size="1.25rem"
            aria-hidden
          />
        )}
      </article>
    </ProviderCardPractitionerItem>
  )
}
